// Branche FE — gating de la branche Tendances.
// Flip TENDANCES_ENABLED = true quand le backend activera la branche.
export const TENDANCES_ENABLED = true;
export const AUDIT_ENABLED = true;
export const VERIF_ENABLED = true;

export type Branch = "business" | "tendances" | "audit" | "verif";

// --- Libellés affichés ---
// Renommage 2026-07 : la valeur technique `audit` s'affiche "Positionnement",
// la valeur technique `verif` s'affiche "Audit". Le mapping est purement
// visuel — la valeur `branch` envoyée au backend reste inchangée.
export const BRANCH_LABEL: Record<Branch, string> = {
  business: "Business",
  tendances: "Tendances",
  audit: "Positionnement",
  verif: "Audit",
};

export function branchLabel(b: Branch | string | null | undefined): string {
  if (!b) return "—";
  return (BRANCH_LABEL as Record<string, string>)[b] ?? String(b);
}

// --- Vérif : un seul mode par design ---
export type VerifMode = "verif";
export const DEFAULT_VERIF_MODE: VerifMode = "verif";
export function isVerifMode(v: unknown): v is VerifMode {
  return v === "verif";
}

export type TendancesClassification = "Micro" | "Saisonnière" | "Macro" | "Méga";
export type TendancesReco = "Acheter" | "Surveiller" | "Ignorer";

export interface TendancesInstrument {
  kind: "tendances";
  classification: TendancesClassification;
  reco: TendancesReco;
  justification: string;
}

export interface BusinessInstrument {
  kind: "business";
}

export type Instrument = TendancesInstrument | BusinessInstrument;

export function isTendancesInstrument(
  i: { kind?: string } | null | undefined,
): i is TendancesInstrument {
  return !!i && i.kind === "tendances";
}

// --- Tendances : sous-menu modes (clés EXACTES backend) ---
// La clé legacy "tendances" est volontairement exclue du menu (catch-all rétro-compat).
export type TendancesMode =
  | "mode_beaute"
  | "deco_design"
  | "alimentaire_boissons"
  | "produits_objets"
  | "innovations_tech"
  | "tiktok_shop"
  | "amazon_ecommerce"
  | "concepts_viraux"
  | "luxe_premium"
  | "instagram_trends"
  | "tendances_general";

export const DEFAULT_TENDANCES_MODE: TendancesMode = "tendances_general";

// --- Business : sous-menu modes (clés EXACTES backend) ---
export type BusinessMode =
  | "auto"
  | "validation"
  | "marche"
  | "pricing"
  | "produit"
  | "levee"
  | "plan"
  | "investissement";

export const DEFAULT_BUSINESS_MODE: BusinessMode = "auto";

export const BUSINESS_MODES: ReadonlyArray<{
  value: BusinessMode;
  label: string;
}> = [
  { value: "auto", label: "Général" },
  { value: "validation", label: "Valider une idée" },
  { value: "marche", label: "Étude de marché" },
  { value: "pricing", label: "Tarification" },
  { value: "produit", label: "Produit / roadmap" },
  { value: "levee", label: "Levée de fonds" },
  { value: "plan", label: "Business plan" },
  { value: "investissement", label: "Investir / racheter une boîte" },
];

export function isBusinessMode(v: unknown): v is BusinessMode {
  return (
    typeof v === "string" &&
    BUSINESS_MODES.some((m) => m.value === v)
  );
}

export const TENDANCES_MODES: ReadonlyArray<{
  value: TendancesMode;
  label: string;
}> = [
  { value: "mode_beaute", label: "Mode & Beauté" },
  { value: "deco_design", label: "Déco & Design" },
  { value: "alimentaire_boissons", label: "Alimentaire & Boissons" },
  { value: "produits_objets", label: "Produits & Objets" },
  { value: "innovations_tech", label: "Innovations Tech" },
  { value: "tiktok_shop", label: "TikTok Shop" },
  { value: "amazon_ecommerce", label: "Amazon & E-commerce" },
  { value: "concepts_viraux", label: "Concepts Viraux" },
  { value: "luxe_premium", label: "Luxe & Premium" },
  { value: "instagram_trends", label: "Tendances Instagram" },
  { value: "tendances_general", label: "Général" },
];

export function isTendancesMode(v: unknown): v is TendancesMode {
  return (
    typeof v === "string" &&
    TENDANCES_MODES.some((m) => m.value === v)
  );
}

// --- Audit : sous-menu modes (clés EXACTES backend) ---
export type AuditMode = "positionnement";

export const DEFAULT_AUDIT_MODE: AuditMode = "positionnement";

export const AUDIT_MODES: ReadonlyArray<{ value: AuditMode; label: string }> = [
  { value: "positionnement", label: "Positionnement" },
];

export function isAuditMode(v: unknown): v is AuditMode {
  return typeof v === "string" && AUDIT_MODES.some((m) => m.value === v);
}


